<template>
    <div class="header-wrapper d-flex justify-content-center">
        <div class="header-container mt-0 mb-3 mb-sm-0">
        <h1 class="header mb-1"><Strong>Verify your identity</Strong></h1>
        <h4 class="sub-header">Let’s verify your identity so you can access the Autodesk network.</h4>
    </div>
    </div>
</template>

<script>
export default {
    name: "IdentityVerificationHeader",
};
</script>

<style scoped>
.header-wrapper {
    background-color: #E5E5E5;
    width: 100%;
}
.header-container {
    max-width: 1200px;
    width: 100%;
    padding: 20px 30px;
}

.header {
    font-size: 24px;
    font-weight: bolder;
    color: black;
    font-family: artifaktElementBold;
    line-height: 34px;
}

.sub-header {
    font-size: 14px;
    color: black;
    font-family: artifaktElementRegular;
}

@media (max-width: 700px) {
    .header-container {
        width: 100%;
        padding: 20px;
        margin-bottom: 0px !important;
    }

    .header {
        font-size: 22px;
    }

    .sub-header {
        font-size: 16px;
    }

    .step-blackdot {
        margin-top: 2px;
        margin-left: 9px;
        font-size: 16px;
    }
}
</style>